// extracted by mini-css-extract-plugin
export default {"item":"Item_item__yTJEt","label":"Item_label__ci-4k","note":"Item_note__Tca5D"};